<template>
  <div class="edit-password">
    <div class="card">
      <div class="card-header">
        <span class="card-title">修改密码</span>
      </div>
      <div class="card-body">
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
          <el-form-item label="账号" prop="userName">
            <el-input v-model="form.userName" placeholder="账号" disabled></el-input>
          </el-form-item>
          <el-form-item label="原密码" prop="oldPassword">
            <el-input v-model="form.oldPassword" type="password" placeholder="请输入原密码" show-password></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input v-model="form.newPassword" type="password" placeholder="请输入新密码" show-password @input="checkPasswordStrength"></el-input>
           
          </el-form-item>
          <el-form-item label="密码强度：">
            <div class="password-strength">
              <div class="strength-item weak active">弱</div>
              <div class="strength-item medium" :class="{ active: passwordStrength >=2 }">中</div>
              <div class="strength-item strong" :class="{ active: passwordStrength === 3 }">强</div>
            </div>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input v-model="form.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="submitForm">保存</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {updateEmail,updatePwd} from '@/api/personal.js'
import { getUser } from '@/utils/auth.js'
import {decrypt, encrypt} from '@/utils/jsencrypt'
export default {
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      form: {
        nickName:'',
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordStrength: 0,
      passwordStrengthText: '',
      passwordStrengthClass: '',
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
   created(){
    this.form.userName=getUser()&&getUser().userName||''
  }, 
  methods: {
    checkPasswordStrength() {
      const password = this.form.newPassword
      
      if (!password) {
        this.passwordStrength = 0
        this.passwordStrengthText = ''
        this.passwordStrengthClass = ''
        return
      }
      
      let score = 0
      
      if (password.length >= 6) {
        score += 10
      }
      
      if (password.length >= 8) {
        score += 10
      }
      
      if (password.length >= 12) {
        score += 10
      }
      
      if (/[A-Z]/.test(password)) {
        score += 10
      }
      
      if (/[a-z]/.test(password)) {
        score += 10
      }
      
      if (/\d/.test(password)) {
        score += 10
      }
      
      if (/[^A-Za-z0-9]/.test(password)) {
        score += 10
      }
      
      if (/[A-Z]/.test(password) && /[a-z]/.test(password) && /\d/.test(password)) {
        score += 10
      }
      
      if (score <= 30) {
        this.passwordStrength = 1
        this.passwordStrengthText = '弱'
        this.passwordStrengthClass = 'weak'
      } else if (score <= 60) {
        this.passwordStrength = 2
        this.passwordStrengthText = '中'
        this.passwordStrengthClass = 'medium'
      } else {
        this.passwordStrength = 3
        this.passwordStrengthText = '强'
        this.passwordStrengthClass = 'strong'
      }
      
      // console.log('密码强度:', this.passwordStrength, '得分:', score)
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          updatePwd(
            {
              oldPassword: encrypt(this.form.oldPassword),
              newPassword: encrypt(this.form.newPassword),
            }
          ).then(res=>{
            if(res.data.code==200&&res.data.data){
              this.$message.success('修改成功')
              this.resetForm()
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.passwordStrength = 0
      this.passwordStrengthText = ''
      this.passwordStrengthClass = ''
    }
  }
}
</script>

<style lang="less" scoped>
.edit-password {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }

    .el-form {
      max-width: 600px;
    }

    .password-strength {
      display: flex;
      gap: 8px;
      margin-top: 8px;
      width: 100%;

      .strength-item {
        flex: 1;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #e4e7ed !important;
        border-radius: 4px;
        font-size: 14px;
        color: #909399 !important;
        transition: all 0.3s;
        cursor: default;

        &.weak.active {
          background-color: #f56c6c !important;
          color: #fff !important;
        }

        &.medium.active {
          background-color: #e6a23c !important;
          color: #fff !important;
        }

        &.strong.active {
          background-color: #67c23a !important;
          color: #fff !important;
        }
      }
    }
  }
}
</style>
